import React from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';
import UnifiedNavV2 from '../../components/common/header/UnificationNav/UnificationNav';
// specific to the pre auth landing pages
// load web-nav in the parent route, so it doesn't flicker when navigating between the pre auth pages

const PreAuthApp = props => (
  <div>
    <StickyContainer>
      <UnifiedNavV2 />
      { props.children }
    </StickyContainer>
  </div>
);

PreAuthApp.propTypes = {
  children: PropTypes.shape({})
};

export default PreAuthApp;



// WEBPACK FOOTER //
// ./src/pages/preauth/PreAuthApp.jsx